export enum ELegalDocType {
  Imprint = "imprint",
  DataProtection = "data-protection",
  Shipping = "shipping",
  Payment = "payment",
  CancellationAndComplaints = "cancellation-and-complaints",
}
